import { createFileRoute } from "@tanstack/react-router";
import { kitsEnvironmentRoutesApiRoute } from "@/features/kits-environments";

export const Route = createFileRoute("/api/internal/kits/environment-routes")({
    ...kitsEnvironmentRoutesApiRoute,
});
